<template>
  <div class="app">
    <notifications group="foo-velocity"
                   position="bottom left"
                   animation-type="velocity"
                   :speed="500" />
    <notifications group="custom-template"
                   :speed="500"
                   :width="500"
                   animation-name="v-fade-left"
                   position="top center"/>

    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/admins" exact>Admins</b-nav-item>
        <b-nav-item v-if="admin.level === 0" class="px-3" to="/organizations" exact>Organizations</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import getAdmin from '../mixins/getAdmin'

export default {
  name: 'full',
  mixins: [
    getAdmin
  ],
  components: {
    AppHeader,
    AppSidebar,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      admin: {},
      company_id: 0,
      device_id: 0,
      index: 0,
      nav: nav.items
    }
  },
  methods: {
    deleteAdminOpen (event) {
      this.admin_id = event.params.id
    },
    deleteAdmin () {
      let that = this

      this.$store.dispatch('deleteAdmin', {admin_id: this.admin_id, notify: this.$notify}).then(() => {
        that.$store.dispatch('getOrganizationAdmins')
      })
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  mounted () {
    this.getAdmin()
  }
}
</script>
